import { call, CallEffect, ForkEffect, takeEvery } from '@redux-saga/core/effects'; // NOSONAR
import {
  GlobalActions,
  GlobalEventDispatcher,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';

export function* watchInitializeLogger(): Generator<ForkEffect> {
  yield takeEvery(GlobalActions.AUTHENTICATION_SUCCESSFUL, safeSaga(initLogger, App.SHOP));
}

function* initLogger(): Generator<CallEffect> {
  PS20Logger.config = {
    error: true,
    info: true,
    globalEventDispatcherRef: GlobalEventDispatcher.getInstance(),
  };
  yield call(GlobalPut.getInstance().put, new GlobalActions().loggerInitialized());
}
